function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgImageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EDEDED"
    },
    points: "461.913,467.478 0,467.478 0,94.609 33.391,94.609 33.391,434.087 461.913,434.087 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.783,
    y: 44.522,
    style: {
      fill: "#D1E5F5"
    },
    width: 445.217,
    height: 311.652
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.391,
    y: 44.522,
    style: {
      fill: "#B4D8F1"
    },
    width: 222.609,
    height: 311.652
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#95D5A7"
    },
    points: "512,289.391 400.696,178.087 267.13,311.652 178.087,222.609 66.783,333.913 66.783,400.696  512,400.696 "
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F8E99B"
    },
    cx: 233.739,
    cy: 144.696,
    r: 33.391
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#80CB93"
    },
    points: "512,289.391 400.696,178.087 289.391,289.391 289.391,400.696 512,400.696 "
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageIcon);
export default __webpack_public_path__ + "static/media/image-icon.e0ce14eb91231f926cb4b57d45d75638.svg";
export { ForwardRef as ReactComponent };